module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon8.01dafcdd.svg";